function mixNumber(from, to, progress) {
  return from + (to - from) * progress;
}
export {
  mixNumber
};
